import type { HttpPost } from '@/shared/infra/http'
import type { LinkClub, LinkClubParams } from '@/modules/auth/use-cases'

export class EdgeLinkClubRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: LinkClub = async (params) => {
    await this.httpClient.post<LinkClubParams, unknown>({
      url: '/users/link-club',
      body: params,
    })
  }
}
